import {
  FormGroup,
  FormGroupFeedback,
  IFormGroupProps,
  IInputGroupProps,
  InputGroup,
  Intent,
} from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import * as React from 'react';

export interface ITextFieldProps {
  children?: React.ReactNode;
  disabled?: boolean;
  fill?: boolean;
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  inputProps?: Omit<IInputGroupProps, 'type' | 'intent'>;
  placeholder?: string;
}

export function TextField<T extends string>({
  children,
  disabled = false,
  fill = true,
  name,
  formGroupProps,
  inputProps,
  placeholder,
}: ITextFieldProps) {
  const [field, meta]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);

  const hasInitialError = meta.initialError;
  const hasError = meta.touched && meta.error;
  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      {children}
      <InputGroup
        dir="auto"
        fill={fill}
        type="text"
        {...field}
        {...inputProps}
        intent={hasError || hasInitialError ? Intent.DANGER : Intent.NONE}
        placeholder={placeholder}
        disabled={disabled}
      />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
      {!hasError && hasInitialError && (
        <FormGroupFeedback intent={Intent.DANGER}>{meta.initialError}</FormGroupFeedback>
      )}
    </FormGroup>
  );
}

export default TextField;
